<page-header [section]="'devices-sys-health'">
  <page-title>Workers</page-title>
  <page-blurb>Worker Telemetry Reports.</page-blurb>
</page-header>
